/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useState } from "react";
import AudioAnalyser from "../../components/audioVisualizer/AudioAnalyser";
import { find } from "lodash";
import { AES, enc } from "crypto-js";
import useSpeechRecorder from "./useSpeechRecorder";
import { TestStatus } from "../../components/constants/constants";
import { useEffect } from "react";
import { useMobileView } from "./MobileViewContext";

export const SpeakingControls = ({
  setIsaudioUpload,
  systemrequirementToggle,
  isStopTimer,
  setIsonRecorder,
  setresetAudio,
  answers,
  data_type,
  data_page_id,
  data_exercise_id,
  data_section_id,
  Studentname,
  testStatus,
  startReadingtime,
  isSubmitting,
}) => {
  let {isMobileView} = useMobileView();
  const [Audioanalyzer, setAudioanalyzer] = useState(null);

  var audio_streaming_data = sessionStorage.getItem("audio_streaming_data");
  try {
    const decrypted = AES.decrypt(audio_streaming_data, "MYKEY4DEMO");
    const decryptedstring = decrypted.toString(enc.Utf8);
    var audioUploadurl = decryptedstring.replace(/&amp;/g, "&");
  } catch (e) {
    console.log(e);
  }

  let [base64, isRecording, startRecording, stopRecording] = useSpeechRecorder(
    audioUploadurl,
    Studentname,
    data_type,
    data_page_id,
    data_exercise_id,
    data_section_id,
    setAudioanalyzer,
    setIsaudioUpload
  );
  if (base64 !== "") {
    let found_section = find(answers, ["section_id", data_section_id]);
    let found_page = find(answers, ["page_id", data_page_id]);
    let found_exercise = find(answers, ["exercise_id", data_exercise_id]);
    if (found_section && found_page && found_exercise) {
      found_exercise.answers = base64;
    } else {
      answers.push({
        section_id: data_section_id,
        page_id: data_page_id,
        exercise_id: data_exercise_id,
        answers: base64,
      });
    }
  }
  useEffect(() => {
   if (startReadingtime && testStatus === TestStatus.Read) {
      startRecording();
   }
  }, [testStatus, startReadingtime]);
  useEffect(() => {
    if (isStopTimer && isRecording) {
      stopRecording();
    }
  }, [isStopTimer, isRecording]);
  if (isRecording) {
    setIsonRecorder(true);
  }
  if (!isRecording) {
    setIsonRecorder(false);
  }
  if (isRecording && data_type === "Assessment") {
    setresetAudio(false);
  }
  return (
    <div
      key={`${data_section_id}${data_exercise_id}`}
      className={`justify-content-center align-items-center d-flex smpx-8 ${isMobileView ? "pt-3 pb-2":"pt-4"}`}
    >
      <div className={!isRecording ? "col-12 d-flex py-3" : `d-flex`} style={{position: "relative"}}>
        {/* <div className="col-3 d-flex justify-content-start align-items-center">
          <svg
            onClick={systemrequirementToggle}
            width="51"
            height="51"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
          >
            <path
              d="M13.125 19L29.625 19M29.625 19C29.625 21.2782 31.4718 23.125 33.75 23.125C36.0282 23.125 37.875 21.2782 37.875 19C37.875 16.7218 36.0282 14.875 33.75 14.875C31.4718 14.875 29.625 16.7218 29.625 19ZM21.375 30L37.875 30M21.375 30C21.375 32.2782 19.5282 34.125 17.25 34.125C14.9718 34.125 13.125 32.2782 13.125 30C13.125 27.7218 14.9718 25.875 17.25 25.875C19.5282 25.875 21.375 27.7218 21.375 30Z"
              stroke="black"
              strokeWidth="2.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              cx="25.5"
              cy="25.5"
              r="23.5385"
              stroke="black"
              strokeWidth="3.92308"
            />
          </svg>
        </div> */}

        <div className={"col-12 d-flex"}>
          {/* <button
            type="button"
            className="justify-content-center btn p-0"
            onClick={isRecording ? stopRecording : startRecording}
            disabled={
              isSubmitting
                ? true
                : testStatus === TestStatus.Read
                ? false
                : true
            }
          >
            <div>
              <span className="text-start">
                {!isRecording ? (
                  <svg
                    width="51"
                    height="51"
                    viewBox="0 0 43 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="21.5" cy="21.5" r="21.5" fill="#F52F37" />
                    <rect
                      x="16.5391"
                      y="6.61719"
                      width="9.92308"
                      height="18.1923"
                      rx="4.96154"
                      stroke="white"
                      stroke-width="3.30769"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.92428 19.8469C9.92428 22.9173 11.144 25.8619 13.3151 28.033C15.4862 30.2041 18.4308 31.4238 21.5012 31.4238C24.5716 31.4238 27.5162 30.2041 29.6873 28.033C31.8584 25.8619 33.0781 22.9173 33.0781 19.8469"
                      stroke="white"
                      stroke-width="3.30769"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.5 36.3839V33.0762"
                      stroke="white"
                      stroke-width="3.30769"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="50" fill="#F52F37" />
                    <rect x="30" y="20" width="12" height="60" fill="white" />
                    <rect x="58" y="20" width="12" height="60" fill="white" />
                  </svg>
                )}
              </span>
            </div>
          </button> */}
          <div class="justify-content-center align-items-center">
            <span>
              {!isRecording ? (
                <p className="record-line-width"></p>
              ) : Audioanalyzer ? (
                <AudioAnalyser audio={Audioanalyzer} width={198} height={60} />
              ) : null}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
